import qs from 'query-string'

export const parseSearch = qs.parse

export const encodeSearch = (...params) => `?${qs.stringify(...params)}`
